import React, { useEffect, useRef, useState } from "react"
import { Modal } from "react-bootstrap"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import { Button } from "components"
import { createSmsPayment, getContract } from "services"
import PaymentGatewaySelector from "../../PaymentGatewaySelector"
import classes from "./TnsbTopupModal.module.scss"

const packages = [250, 500, 1000, 5000, 20000, 100000]

const TnsbTopupModal = props => {
  const {
    selectedBranch,
    openTopupModal,
    setOpenTopupModal
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)
  const [smsUnitPrice, setSmsUnitPrice] = useState(null)
  const [selectedSmsAmount, setSelectedSmsAmount] = useState(null)
  const [paymentGateway, setPaymentGateway] = useState("haghighi_a2a")

  const unmount = useRef(false)

  const handleExited = () => {
    setSelectedSmsAmount(null)
  }

  const handleEnter = async () => {
    try {
      const response = await getContract()

      if (unmount.current) return

      setSmsUnitPrice(response.smsPrice)
    } catch (err) {
      console.log(err)
    }
  }

  const handleTopup = async () => {
    if (selectedSmsAmount === null) return

    setSending(true)

    try {
      const { gatewayUrl } =
        await createSmsPayment({
          branchId: selectedBranch._id,
          type: paymentGateway,
          smsAmount: Number(selectedSmsAmount)
        })

      window.location.href = gatewayUrl
    } catch (err) {
      console.log(err)

      toast.error(t("عملیات_انجام_نشد"))

      if (unmount.current) return

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  const disablePayButton =
    smsUnitPrice === null ||
    selectedSmsAmount === null

  return (
    <Modal
      show={openTopupModal}
      onHide={() => setOpenTopupModal(false)}
      backdrop="static"
      onEnter={handleEnter}
      onExited={handleExited}
      centered
    >
      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {t("افزایش_موجودی_پیامک_ها")}
        </div>

        <div className={classes["row"]}>
          {packages.map(p =>
            <div
              key={p}
              className={clsx(classes["box"], selectedSmsAmount === p && classes["active"])}
              onClick={() => setSelectedSmsAmount(p)}
            >
              {p}
            </div>
          )}
        </div>

        <div className={classes["checkout"]}>
          <div className={classes["item"]}>
            <b className={classes["total"]}>
              {t("قابل_پرداخت")}
            </b>

            <b className={classes["total"]}>
              {thousandSeparator(smsUnitPrice * selectedSmsAmount)}
            </b>
          </div>
        </div>

        <PaymentGatewaySelector
          value={paymentGateway}
          disabled={sending}
          onChange={setPaymentGateway}
        />

        <div className={classes["footer"]}>
          <Button
            color="success"
            className={classes["button"]}
            loading={sending}
            disabled={disablePayButton}
            onClick={handleTopup}
          >
            {t("پرداخت")}
          </Button>

          <Button
            disabled={sending}
            onClick={() => setOpenTopupModal(false)}
            color="danger"
          >
            {t("بازگشت")}
          </Button>
        </div>
      </div>
    </Modal>

  )
}

export default TnsbTopupModal
